<template>
    <BaseWidthContainer class="mt-16 mb-9">
        <slot />
    </BaseWidthContainer>
</template>
